import { render, staticRenderFns } from "./SDS-Liquid.vue?vue&type=template&id=3bf0303c&scoped=true&"
import script from "./SDS-Liquid.vue?vue&type=script&lang=js&"
export * from "./SDS-Liquid.vue?vue&type=script&lang=js&"
import style0 from "./SDS-Liquid.vue?vue&type=style&index=0&id=3bf0303c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0303c",
  null
  
)

export default component.exports